<template>
  <div class="invitePersonPlan">
    <div class="top">
      <el-button type="primary" plain @click="back">返回</el-button>
    </div>
    <div class="content clearfix">
      <div class="right">
        <el-form ref="form" :model="form" :inline="true" label-width="120px">
          <div class="my-table">
            <div class="my-title fl">填写手机号码，邀请指定用户加入项目</div>
            <div v-for="(item, $index) in form.list" :key="$index" class="clear" style="margin-top:10px;">
              <device-info :index="$index" :device-info="item" :list="form.list" @removeComponent="removeComponent" @addComponent="addComponent" :type="2" :addType="addType"></device-info>
            </div>
          </div>
        </el-form>
        <div class="submitReportBox">
          <el-button :loading="lodinging" type="primary" @click="submitReport('form')" >确认邀请</el-button >
        </div>
      </div>
    </div>
    <el-dialog v-dialogDrag v-if="professionDialogVisible" :visible.sync="professionDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"  title="邀请成功" custom-class="profession-dialog" width="500px" >
      <span>
        <p class="fontTop">已邀请用户加入项目</p>
        <p>若用户暂未加入企业，则需用户先同意加入企业后才可成功加入项目</p>
        <p>快复制链接邀请用户吧~</p>
        <p style="margin-top:20px">
          <el-button type="primary" @click="confirmAddSpec" >复制邀请链接</el-button >
        </p>
      </span>
    </el-dialog>
    <Vcode :show="isShow" :canvas-width="349" :canvas-height="209" class="vue-puzzle-vcodeone" @success="onSuccess" @close="onclose"/>
  </div>
</template>

<script>
import deviceInfo from "@/views/components/invitePeople";
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import Vcode from "vue-puzzle-vcode";
import { mapState } from "vuex";
import { baseUrlWeb}from "@/CommonDP/utils"
export default {
  components: { deviceInfo, Vcode },
  data() {
    let telephone1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("手机号格式错误!"));
      } else {
        callback();
      }
    };
    let neiwaibu2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择人员类别"));
      } else {
        callback();
      }
    };
    let specRole2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择所属角色"));
      } else {
        callback();
      }
    };
    let bumen = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择供方公司"));
      } else {
        callback();
      }
    };
    return {
      form: {
        list: [
          { phone: "",
            neiwaibu: "",
            bumen: "",
            bumenid: "",
            specRole:'',
            rules: {
              telephone: { trigger: "change", validator: telephone1 },
              neiwaibu1: { trigger: "change", validator: neiwaibu2 },
              specRole1: { trigger: "change", validator: specRole2 },
              bumen: { trigger: "change", validator: bumen },
            }
          }
        ]
      },
      form1: {
        list: [
          { phone: "",
            neiwaibu: "",
            bumen: "",
            bumenid: "",
            specRole:'',
            rules: {
              telephone: { trigger: "change", validator: telephone1 },
              neiwaibu1: { trigger: "change", validator: neiwaibu2 },
              specRole1: { trigger: "change", validator: specRole2 },
              bumen: { trigger: "change", validator: bumen },
            }
          }
        ]
      },
      lodinging: false,
      professionDialogVisible: false,
      lianjie: "",
      isShow: false, // 验证码模态框是否出现
      datalist: [],
      join1:require('@/CommonDP/assets/addpersonInfo/invitejoin.png'),
      addp: require('@/CommonDP/assets/addpersonInfo/addp.png'),
      join2: require('@/CommonDP/assets/addpersonInfo/协同小助手.png'),
      repeat: '',
      repeat2: "",
      addType:'0'
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
    })
  },

  created () {
    const {addType} = this.$route.query
    this.addType = addType
    const {list} = this.form
    const {list:list1} = this.form1
    list[0].neiwaibu = this.addType
    list1[0].neiwaibu = this.addType
  },

  methods: {
    back() {
      this.$router.push({name:"personPlan"});
    },
    addComponent(index) {
      let ii = index + 1;
      let ll = this.form.list.length;
      if (ll == ii) {
        let telephone1 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请输入手机号"));
          } else if (!/^1[3-9]\d{9}$/.test(value)) {
            callback(new Error("手机号格式错误!"));
          } else {
            this.repeat = callback
            this.repeat2 = value
            this.querymo()
          }
        };
        let neiwaibu2 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请选择人员类别"));
          } else {
            callback();
          }
        };
        let specRole2 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请选择所属角色"));
          } else {
            callback();
          }
        };
        let bumen = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请选择供方公司"));
          } else {
            callback();
          }
        };
        this.form.list.push({
          phone: "",
          neiwaibu:this.addType,
          bumen: "",
          bumenid: "",
          specRole:'',
          rules: {
            telephone: { trigger: "change", validator: telephone1 },
            neiwaibu1: { trigger: "change", validator: neiwaibu2 },
            specRole1: { trigger: "change", validator: specRole2 },
            bumen: { trigger: "change", validator: bumen },
          }
        });
      }
    },
    querymo() {
      let encoded = encodeURI(this.repeat2);
      let pilots = this.form.list
      const rebels = pilots.filter(pilot => pilot.phone === encoded);
      if (rebels.length >= 2) {
        this.repeat(new Error('手机号不能重复'))
      } else {
        this.repeat()
      }
    },
    removeComponent(index) {
      this.form.list.splice(index, 1);
    },
    submitReport() {
      this.lianjie = "";
      const { prjId } = this.prjInfo;
      const phones = this.form.list.filter(item => item.phone !== "");
      const neiwaibus = this.form.list.filter(item => item.neiwaibu !== "");
      const specRole = this.form.list.filter(item => item.specRole !== "");
      if (phones.length || neiwaibus.length || specRole.length) {
        let data = [];
        this.form.list.forEach((value, key) => {
          if (value.phone) {
            if (!value.neiwaibu) {
              this.$refs.form.validateField("list." + key + ".neiwaibu");
            } else if (!/^1[3-9]\d{9}$/.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!value.specRole) {
              this.$refs.form.validateField("list." + key + ".specRole");
            }else if (!value.bumen&&this.addType==="1") {
              this.$refs.form.validateField("list." + key + ".bumen");
            }  else {
              let tt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid,
                prjId:prjId,
                specId:'default',
                roleId:value.specRole[1],
              };
              data.push(tt);
            }
          } else if (value.neiwaibu) {
            if (!value.phone) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!/^1[3-9]\d{9}$/.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else {
              let ttt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid,
                prjId:prjId,
                specId:'default',
                roleId:value.specRole[1],
              };
              data.push(ttt);
            }
          } else if (value.specRole) {
            if (!value.phone) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!/^1[3-9]\d{9}$/.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            }else if (!value.neiwaibu) {
              this.$refs.form.validateField("list." + key + ".neiwaibu");
            }else if (!value.bumen&&this.addType==="1") {
              this.$refs.form.validateField("list." + key + ".bumen");
            } else {
              let ttt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid,
                prjId:prjId,
                specId:'default',
                roleId:value.specRole[1],
              };
              data.push(ttt);
            }
          }else if (value.bumen) {
            if (!value.phone) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!/^1[3-9]\d{9}$/.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            }else if (!value.neiwaibu) {
              this.$refs.form.validateField("list." + key + ".neiwaibu");
            } else {
              let ttt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid,
                prjId:prjId,
                specId:'default',
                roleId:value.specRole[1],
              };
              data.push(ttt);
            }
          }
        });
        console.log(data, "提交");
        if (data.length >= 1) {
          console.log("调添加接口");
          this.isShow = true;
          this.datalist = data;
        }
      } else {
        this.$message({
          duration: 1000,
          message: "最少加一人",
          type: "warning"
        });
      }
    },
    onSuccess() {
      this.isShow = false;
      this.lodinging = true;
      let params = {
        enterpriseId: this.enterpriseId,
        userList: this.datalist,
      };
      console.log(this.form,'this.form');
      console.log(params,'params');
      systemPersonService.invitationPersonInPrj(params).then(res => {
        if (res.result == "0") {
          this.professionDialogVisible = true;
          this.lianjie = res.data;
          this.lodinging = false;
          this.form = this.form1;
          this.$nextTick(() => {
            this.$refs["form"].resetFields();
          });
        }
      }).catch(() => {
        this.lodinging = false;
      });
    },
    D() {
      this.professionDialogVisible = false;
    },
    confirmAddSpec() {
      let code = "";
      code = baseUrlWeb() + "/joinEnterprise?code=" + this.lianjie;
      this.$copyText(code).then(res => {
        this.professionDialogVisible = false;
        this.$message.success("链接复制成功!");
      });
    },
    onclose() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.invitePersonPlan {
  height: 100%;
  min-width:100%;
  background: #fff;
  position: relative;
  .top{
    height:57px;
    line-height:57px;
    border-bottom:1px solid #d3d9e8c4;
    padding-left:18px
  }
  .content{
    background: #F4F5FA;
    border-radius: 4px;
    margin-left:18px;
    margin-right:18px;
    height:calc(100% - 96px);
    margin-top:19px;
    position: relative;
  }
  .my-table .btn-table {
    left: 28px;
    width: calc(100% - 28px);
  }
  .el-button--small {
    width: auto;
  }
  .my-form .el-input__inner,
  .my-table .el-input__inner {
    width: 160px;
    height: 30px;
    line-height: 30px;
  }
  .detail-info .el-input__inner {
    width: 480px;
  }
  .el-textarea__inner {
    width: 625px;
  }
  .el-form-item__content{
    height: 40px;
  }
  .left{
    position: absolute;
    right: 30px;
    top: 30px;
    display: flex;
    align-items: center;
    flex-flow: column nowrap;
    justify-content: center;
    filter: blur(10px);
    // float: left;
    // .join1{
    //   margin-top:147px;
    //   margin-left:198px
    // }
    // .addp{
    //   margin-top:70px;
    //   margin-left:19px
    // }
    // .join2{
    //   margin-top:40px;
    //   margin-left:198px
    // }
  }
  .right{
    float: left;
    margin-left:73px;
    width: 930px;
    position: relative;
    padding: 10px 20px;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden auto;
    &::after {
      position: absolute;
      content: '';
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      z-index: -1;
      background-color: transparent;
    }
    /deep/ .el-input__inner{
      width: 210px!important;
    }
    /deep/ .el-form-item{
      margin-bottom:15px
    }
  }
  .clearfix:after{ /* 正常浏览器 清除浮动 */
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .clearfix{
    *zoom: 1; /* zoom 1 就是ie6 清除浮动的方法 * 是ie7以下的版本所识别 */
  }
  .my-title{
    font-size:18px;
    margin-top:45px;
    margin-bottom:20px
  }
  .submitReportBox{
    text-align: right;
    margin-right: 63px;
  }
  /deep/ .profession-dialog{
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
      box-sizing: border-box;
      p{
        text-align: center;
        height:25px;
        line-height:25px;
      }
      .fontTop{
        color:#4777E7;
        font-size:15px;
      }
    }
  }

}
</style>
<style>
.vue-puzzle-vcodeone {
  z-index: 9999!important;
}
</style>
